<ul class="emotion-map-holder">
  <li *ngFor="let emotion of emotions"
    id="emotionMapItem{{emotion.name}}">
    <i class="dot {{ emotion?.className }}"></i>
    <span class="emotion-name {{ emotion?.className }}"
      [attr.title]="emotion.title">{{ emotion.title }}
    </span>
  </li>
</ul>
